import React, { useContext } from 'react';
import { makeStyles, Tab } from '@material-ui/core';
import { colorSet } from '@components/Provider';
import { CompanyInfoContext } from '../context/CompanyInfoContext';
import CompanyNavButtons from './CompanyNavButtons';

const CompanyInfoNavigation: React.FunctionComponent = () => {
  const { companyInfoNavigation, companybuttons } = useStyles();
  const context = useContext(CompanyInfoContext);

  if (!context) return null;
  const { partnerInfo } = context;
  const hasPortfolio = (partnerInfo?.portfolios ?? []).length > 0;
  const hasEquips = (partnerInfo?.equipments ?? []).length > 0;
  const hasCertificate = (partnerInfo?.certifications ?? []).length > 0;
  const hasImageOrVideo = (context.partnerInfo?.partnerFiles ?? []).length > 0;
  const hasPatents = (partnerInfo?.patents ?? []).length > 0;
  const hasReviews = (partnerInfo?.reviews?.reviews ?? []).length > 0;

  return (
    <div className={companyInfoNavigation}>
      <Tab label="회사소개" href="#introduction" />
      {hasPortfolio && <Tab label="포트폴리오" href="#portfolio" />}
      {hasImageOrVideo && (
        <Tab label="사진 및 동영상" href="#gallery" value="gallery" />
      )}
      {hasEquips && <Tab label="보유장비" href="#equipments" />}
      {hasCertificate && <Tab label="인증" href="#certificate" />}
      {hasPatents && <Tab label="특허" href="#patent" />}
      {hasReviews && <Tab label="리뷰" href="#review" />}
      <div className={companybuttons}>
        <CompanyNavButtons />
      </div>
    </div>
  );
};

export default CompanyInfoNavigation;

const useStyles = makeStyles((theme) => ({
  companyInfoNavigation: {
    display: 'flex',
    maxWidth: '1024px',
    width: '100%',
    gap: '24px',
    '& a': {
      opacity: 1,
      padding: 0,
      minWidth: 'unset',
      height: '60px',
      '&:hover': {
        borderBottom: `2px solid ${colorSet.gray900}`,
        '& > span': {
          transform: 'translateY(1px)'
        }
      }
    },
    '& .MuiTab-wrapper': {
      ...theme.typography.body1,
      fontWeight: 500,
      color: colorSet.gray900
    }
  },
  companybuttons: {
    marginLeft: 'auto',
    marginTop: 10
  }
}));
